module.exports = __webpack_public_path__ + "img/theme-moon.55ef09e4.svg";